var _circle, _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WearFaceShield50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.979,38c-0.001,0-0.002,0-0.003,0c-5.348-0.005-8.628-1.694-10.437-3.111 C22.561,34.123,22,32.973,22,31.732V16h15v19.012c0,0.807-0.318,1.562-0.896,2.126C35.535,37.694,34.78,38,33.979,38z M24,18v13.732 c0,0.621,0.281,1.197,0.772,1.582c1.279,1.001,4.176,2.681,9.207,2.686c0,0,0,0,0.001,0c0.275,0,0.534-0.104,0.727-0.293 C34.896,35.522,35,35.275,35,35.012V18H24z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 3,
    x: 10,
    y: 21,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26,38h-2v-4h3.262C28.771,34,30,32.793,30,31.309v-4.381l0.615-0.256c0,0,1.331-0.555,1.414-0.59 l-0.093-0.1L30,22.376V21c0-5.514-4.262-10-9.5-10S11,15.486,11,21c0,4.516,1.301,6.931,2.449,9.061 C14.247,31.541,15,32.938,15,34.676V38h-2v-3.324c0-1.232-0.579-2.307-1.312-3.666C10.491,28.787,9,26.021,9,21 c0-6.617,5.159-12,11.5-12S32,14.383,32,21v0.874l1.675,3.12c0.347,0.534,0.42,1.202,0.195,1.801 c-0.185,0.493-0.547,0.887-1.018,1.109c-0.01,0.005-0.455,0.19-0.852,0.356v3.048C32,33.896,29.875,36,27.262,36H26V38z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WearFaceShield50);
export default __webpack_public_path__ + "static/media/icons8-wear-face-shield-50.3409dca8ace3a91e8b94b3c168cd8288.svg";
export { ForwardRef as ReactComponent };